import {
  INIT_VIDEOS,
  UPDATE_VIDEO,
  DELETE_VIDEO,
  ADD_VIDEO,
} from 'components/Video/videoActionTypes';

export const initialState = [];

export default function (state = initialState, action) {
  switch (action.type) {
    case INIT_VIDEOS:
      return action.data;
    case UPDATE_VIDEO:
      return state.map((video) => {
        if (video._id == action.data._id) {
          video = { ...video, ...action.data };
        }
        return video;
      });
    case DELETE_VIDEO:
      return state.filter((video) => video._id !== action.videoId);
    case ADD_VIDEO:
      return [...state, action.video];
    default:
      return state;
  }
}
